"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { CheckCircle } from "lucide-react"

export default function Prices() {
  const scrollToBooking = () => {
    const element = document.getElementById("booking")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  const features = ["Индивидуальная психотерапия", "Консультация по психосоматике", "Гипнотерапия", "Коучинг-сессии"]
  const messageFeatures = ["В переписке и аудиосообщениях", "В острой и непонятной ситуации", "Психологическая консультация и поддержка", "Помощь в поиске решений"]

  return (
    <section id="prices" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Стоимость услуг</h2>
          <p className="text-xl text-gray-600">Прозрачная и честная цена за качественную психологическую помощь.</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row md:gap-20 gap-8 items-stretch">
          <Card className="overflow-hidden shadow-2xl border-0 flex-1 h-full">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-center py-8">
              <CardTitle className="text-2xl font-semibold mb-2">Индивидуальная сессия</CardTitle>
              <div className="text-4xl font-bold mb-2">5 000 ₽</div>
              <p className="text-blue-100">Продолжительность: 60-90 минут (онлайн)</p>
            </CardHeader>

            <CardContent className="p-8">
              <ul className="space-y-4 mb-8">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={scrollToBooking}
                size="lg"
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-3 rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Записаться
              </Button>
            </CardContent>
          </Card>
          <Card className="overflow-hidden shadow-2xl border-0 flex-1 h-full">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-purple-600 text-white text-center py-8">
              <CardTitle className="text-2xl font-semibold mb-2">Консультация в мессенджере</CardTitle>
             <div className="text-4xl font-bold mb-2"> 3 000 ₽</div>
              <p className="text-blue-100">Продолжительность: до 120 минут</p>
            </CardHeader>

            <CardContent className="p-8">
              <ul className="space-y-4 mb-8">
                {messageFeatures.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={scrollToBooking}
                size="lg"
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-3 rounded-full transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Записаться
              </Button>
            </CardContent>
          </Card>
          </div>
        </div>
      </div>
    </section>
  )
}
